var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"mx-2",attrs:{"append-icon":"search","label":_vm.label,"single-line":"","hide-details":""},on:{"keyup":_vm.search},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }